// Constantes de l'application

// Navigation
export const DRAWER_WIDTH = 260

// Routes
export const ROUTES = {
  HOME: '/',
  TO_READ: '/to-read',
  LOGIN: '/login',
  PROFILE: '/profile',
  STATISTICS: '/statistics',
  SERIES: '/series',
}

// Pagination
export const DEFAULT_PAGE_SIZE = 20
export const DEFAULT_PAGE = 0

// Tri
export const SORT_OPTIONS = {
  TITLE: 'title',
  PRIORITY: 'priority',
  RATING: 'rating',
}

export const ORDER_OPTIONS = {
  ASC: 'asc',
  DESC: 'desc',
}

// Durées
export const DEBOUNCE_DELAY = 350
export const TOKEN_EXPIRY_HOURS = 3

// URLs par défaut
export const DEFAULT_BOOK_IMAGE =
  'https://i0.wp.com/castlewoodassistedliving.com/wp-content/uploads/2021/01/image-coming-soon-placeholder.png?fit=1000%2C1000&ssl=1'

// Messages
export const ERROR_MESSAGES = {
  LOGIN_FAILED: 'Identifiant ou mot de passe incorrect.',
  NETWORK_ERROR: 'Une erreur réseau est survenue.',
  LOAD_BOOKS_ERROR: 'Erreur lors du chargement des livres.',
  LOAD_PROFILE_ERROR: 'Erreur lors du chargement du profil.',
  INVALID_DATA: 'Erreur lors du traitement des données.',
}
